"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const js_api_loader_1 = require("@googlemaps/js-api-loader");
const useGooglePlacesService = (args) => {
    const { apiKey, apiOptions, onLoadFailed } = args;
    const [placesService, setPlacesService] = (0, react_1.useState)(undefined);
    const [sessionToken, setSessionToken] = (0, react_1.useState)(undefined);
    const initializeService = () => {
        if (!window.google)
            throw new Error("[react-google-places-autocomplete]: Google script not loaded");
        if (!window.google.maps)
            throw new Error("[react-google-places-autocomplete]: Google maps script not loaded");
        if (!window.google.maps.places)
            throw new Error("[react-google-places-autocomplete]: Google maps places script not loaded");
        setPlacesService(new window.google.maps.places.AutocompleteService());
        setSessionToken(new google.maps.places.AutocompleteSessionToken());
    };
    (0, react_1.useEffect)(() => {
        const init = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!apiKey) {
                return;
            }
            try {
                if (!window.google || !window.google.maps || !window.google.maps.places) {
                    yield new js_api_loader_1.Loader(Object.assign({ apiKey }, Object.assign({ libraries: ["places"] }, apiOptions))).load();
                }
                initializeService();
            }
            catch (error) {
                if (typeof onLoadFailed === "function") {
                    onLoadFailed(error);
                }
            }
        });
        if (apiKey) {
            init();
        }
        else {
            initializeService();
        }
    }, []);
    return { placesService, sessionToken, setSessionToken };
};
exports.default = useGooglePlacesService;
//# sourceMappingURL=useGooglePlacesService.js.map